import { ToolbarList } from './toolbarTypes';

export enum CurrentToolbarActionType {
    CURRENT_TOOLBAR_UPDATED = 'CURRENT_TOOLBAR_UPDATED',
}

export type CurrentToolbarUpdatedAction = {
    type: CurrentToolbarActionType;
    currentToolbar: ToolbarList;
};

export const updateCurrentToolbar = (currentToolbar: ToolbarList): CurrentToolbarUpdatedAction => ({
    type: CurrentToolbarActionType.CURRENT_TOOLBAR_UPDATED,
    currentToolbar,
});
